export default function reducer(state = {
    errors: null,
    error_page: "",
    access_token: null,
    keep_login: null,
    recovery: null,
    redirect_page: "",
    profile: null,
    register: null,
    user: null,
    baseline: true,
    keep_login: false,
    mail: false,
    company: null,
    two_factor_dialog: false
}, action) {
    switch (action.type) {
        case "PAGE_ERRORS": {
            return { ...state, errors: action.errors, error_page: action.page }
        }
        case "STORE_REGISTER_DETAILS":{
            return { ...state,
                baseline: false,
                register: action.register,
                access_token: action.token,
                user: action.user,
                keep_login: action.keep_login
            }
        }
        case "STORE_BASELINE_SCORE": {
            return {
                ...state,
                baseline: true
            }
        }
        case "STORE_ACCESS_TOKEN": {
            return { ...state,
                access_token: action.token,
                user: action.user,
                baseline: action.baseline,
                keep_login: action.keep_login
            }
        }
        case "CLEAR_USER": {
            return { ...state, 
                errors: null,
                error_page: "",
                access_token: null,
                keep_login: null,
                recovery: null,
                redirect_page: "log out",
                profile: null,
                register: null,
                user: null,
                baseline: true
            }
        }
        case "KEEP_LOGIN": {
            return { ...state, keep_login: action.date }
        }
        case "RECOVERY_ERROR": {
            return { ...state, recovery: action.message }
        }
        case "REDIRECT_PAGE": {
            return { ...state, redirect_page: action.page }
        }
        case "STORE_PROFILE": {
            return { ...state, profile: action.profile }
        }
        case "CONTACT_MAIL_SEND": {
            return { ...state, mail: action.bool }
        }
        case "STORE_DASHBOARD_DATA":{
            return { ...state, user: {
                ...state.user,
                essential_test: action.data.essential_test,
                voluntary_test: action.data.voluntary_test
            } }
        }
        case "PAGE_QUESTION_UPDATED": {
            return { ...state, user: {
                ...state.user,
                [action.name]: true
            } }
        }
        case "STORE_COMPANY_DETAILS":{
            return { ...state, company:action.data }
        }
        case "TWO_FACTOR_DIALOG":{
            return { ...state, two_factor_dialog:action.bool }
        }
        default:
            break;
    }
    return state;
}